<!--
  TEMPORARY: Invoices section maintenance lock.
  Renders a non-closable modal over the Invoices section.
  To re-enable the section, see src/views/invoices/Invoices.vue (revert the
  commented-out <router-view />) and delete this component + its i18n keys
  (`invoicesMaintenance`).
-->
<template>
  <div class="invoices-maintenance">
    <div
      class="invoices-maintenance__dialog"
      role="dialog"
      aria-modal="true"
    >
      <h2 class="invoices-maintenance__title">
        {{ $t('invoicesMaintenance.title') }}
      </h2>
      <p class="invoices-maintenance__body">
        {{ $t('invoicesMaintenance.body') }}
      </p>
      <p class="invoices-maintenance__body">
        {{ $t('invoicesMaintenance.contactPrefix') }}
        <a
          class="invoices-maintenance__email"
          href="mailto:amministrazione@complifegroup.com"
        >amministrazione@complifegroup.com</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoicesMaintenanceModal',
};
</script>

<style lang="scss">
.invoices-maintenance {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - #{$header-height} - 40px);
  padding: 40px 20px;
  background-color: rgba(0, 0, 0, 0.45);

  &__dialog {
    box-sizing: border-box;
    width: 500px;
    max-width: 100%;
    padding: 24px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    text-align: center;
  }

  &__title {
    margin: 0 0 16px;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.3;
  }

  &__body {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    margin: 0 0 0.625rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__email {
    font-size: 0.875rem;
    font-weight: 500;
  }
}
</style>
